import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HelpOverlay = ({ isVisible, onClose }) => {
  const helpSections = [
    {
      title: 'نحوه استفاده از ربات',
      items: [
        'سوال خود را به زبان فارسی و به صورت واضح بپرسید',
        'از جملات کامل و مفصل استفاده کنید',
        'جزئیات مربوط به موضوع را ذکر کنید',
      ],
    },
    {
      title: 'نوع سوالات قابل پرسش',
      items: [
        'حقوق کار و استخدام',
        'قراردادها و معاملات',
        'حقوق خانواده و ازدواج',
        'املاک و مستغلات',
        'حقوق جزایی و کیفری',
      ],
    },
    {
      title: 'محدودیت‌ها',
      items: [
        'پاسخ‌ها جنبه مشاورهای دارد',
        'برای موارد پیچیده با وکیل مشورت کنید',
        'اطلاعات شخصی حساس را ارسال نکنید',
      ],
    },
  ];

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[300] bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-popover rounded-lg shadow-moderate max-w-2xl w-full max-h-[80vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl font-semibold text-popover-foreground">
            راهنمای استفاده از ایران‌داد
          </h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-smooth focus-ring rounded-md p-2">
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {helpSections?.map((section, index) => (
            <div key={index} className="space-y-3">
              <h3 className="text-lg font-medium text-popover-foreground flex items-center">
                <Icon
                  name="CheckCircle"
                  size={20}
                  className="text-success ml-2"
                />
                {section?.title}
              </h3>
              <ul className="space-y-2 mr-6">
                {section?.items?.map((item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className="flex items-start text-sm text-muted-foreground">
                    <Icon
                      name="ArrowLeft"
                      size={16}
                      className="text-primary ml-2 mt-0.5 flex-shrink-0"
                    />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact Information */}
          <div className="p-4 bg-muted rounded-lg">
            <h4 className="text-sm font-medium text-foreground mb-2 flex items-center">
              <Icon name="Phone" size={16} className="text-primary ml-2" />
              نیاز به مشاوره تخصصی دارید؟
            </h4>
            <p className="text-sm text-muted-foreground mb-3">
              برای موارد پیچیده و تخصصی، می‌توانید با وکلای متخصص ما تماس
              بگیرید.
            </p>
            <div className="flex flex-col sm:flex-row gap-2">
              <Button variant="outline" size="sm" className="flex-1">
                <Icon name="Phone" size={16} className="ml-2" />
                تماس تلفنی
              </Button>
              <Button variant="outline" size="sm" className="flex-1">
                <Icon name="MessageSquare" size={16} className="ml-2" />
                چت با وکیل
              </Button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t border-border">
          <Button onClick={onClose} variant="default">
            متوجه شدم
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HelpOverlay;
